import { useState } from "react";
import useTranslation from "@hooks/use_translation";
import useDevice from "@hooks/use_device";
import { Body } from "@sprout/typography";
import { IconButton } from "@sprout/icon_button";
import CloseIcon from "@sprout/icons/close";
import ErrorIcon from "@sprout/icons/error";

const DISMISSED_KEY = "profileCalloutDismissed";

const ProfileCallout = () => {
  const { t } = useTranslation("user", { keyPrefix: "profile_callout" });
  const { isMobile } = useDevice();
  const [dismissed, setDismissed] = useState(localStorage.getItem(DISMISSED_KEY) === "true");

  if (dismissed) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(DISMISSED_KEY, "true");
  };

  return (
    <div className="mt-6 flex items-start gap-4 rounded-[5px] bg-pale-blue px-6 py-4">
      <div className="shrink-0">
        <ErrorIcon color="blue" size="md" ariaHidden />
      </div>
      <div className="min-w-0 flex-1">
        <Body medium>{t(isMobile ? "mobile_title" : "title")}</Body>
        <Body>{t(isMobile ? "mobile_body" : "body")}</Body>
      </div>
      <div className="-m-1 shrink-0">
        <IconButton label={t("dismiss")} icon={CloseIcon} size="md" onClick={handleDismiss} />
      </div>
    </div>
  );
};

export default ProfileCallout;
